import gql from 'graphql-tag';

export const DOWNLOAD_ANON_POLICY_DOC = gql`
  query ($policyId: ID!, $asOfDate: String!) {
    signedUrl: getRedactedPolicyPDF(policyId: $policyId, asOfDate: $asOfDate)
  }
`;

export const GENERATE_TEMPORARY_DOCUMENT = gql`
  query ($policyId: ID!, $previewId: ID!, $docType: Int, $email: String!, $addedChangeKey: String) {
    signedUrl: generateTemporaryDocument(
      policyId: $policyId
      previewId: $previewId
      docType: $docType
      email: $email
      addedChangeKey: $addedChangeKey
    )
  }
`;
